module.exports = __webpack_public_path__ + "img/B4-20190410_05.61d95da5.jpg";